export default "query exportStudentExcelForUserManage($queryDTO: UserManageStudentQueryDTO) {\n  exportStudentExcelForUserManage(queryDTO: $queryDTO) \n}";